/**
 * XinYuanWebChatX
 * zxw 
 * 创建时间：2025-03-14 
 * 更新时间：2025-12-02
 * 更新内容：Ant Design X 从1.0.0 升级到 2.0.0
 */

import { useState, useEffect, useRef } from 'react';
import $ from 'jquery';
import cookie from 'react-cookies';
import {
    Sender,
    Suggestion,
    Bubble,
    Welcome
} from '@ant-design/x';
import {
    useXChat,
    XRequest,
} from '@ant-design/x-sdk';
import { XMarkdown } from '@ant-design/x-markdown';
import '@ant-design/x-markdown/themes/light.css';
import HighlightCode from '@ant-design/x-markdown/plugins/HighlightCode';   // 代码高亮
import Latex from '@ant-design/x-markdown/plugins/Latex';   // 公式
import Mermaid from '@ant-design/x-markdown/plugins/Mermaid'; // 图表
import {
    Button,
    message,
    theme,
    Space,
    Typography,
    Flex,
    Popover,
    Select,
    Image,
    Avatar,
} from 'antd';
import {
    UserOutlined,
    PlusOutlined,
    CopyOutlined,
    EnterOutlined,
    LineChartOutlined,
    ProfileOutlined,
    AppstoreOutlined,
    FolderOutlined,
    FileMarkdownOutlined,
    FolderViewOutlined,
    GlobalOutlined,
} from '@ant-design/icons';
import {
    QuantityRequirementIcon,
    HybridQueryIcon,
    WOIcon,
    SupplierIcon,
    IntersectionIcon,
} from '../../incs/Icons';
import {
    AddRequestHeaders,
    winHeight,
    ToScrollBottom,
    isGTscreenWidth,
    ClearMarkdown,
    rootReactDom,
    winWidth,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';

import CommandX from './CommandX';
import AssistantBoxView from './AssistantBoxView';

// 自定义数据提供
import XinYuanProvider from './XinYuanProvider';

// 思维链
import XinYuanThink from './XinYuanThink';

// 图表
import ChartPiePercent from '../templates/ChartPiePercent'; // 分类百分比（饼图）
import ChartLineUTACD from '../templates/ChartLineUTACD'; // 每日用户活跃统计
import ChartLineUTECY from '../templates/ChartLineUTECY'; // 年度入职人数趋势
import OrgStructureGraph from '../templates/OrgStructureGraph'; // 组织架构图

import ChartLineDateCount from '../templates/ChartLineDateCount'; // 日期数量走势组件（曲线图）
import ChartIntervalTypeCount from '../templates/ChartIntervalTypeCount'; // 类型数量分布组件（柱状图）

import ChartILYearAmount from '../templates/ChartILYearAmount';   // 年度金额趋势统计（柱状和曲线混合图）
import ChartIntervalMonthIOAmount from '../templates/ChartIntervalMonthIOAmount'; // 月份收支统计（柱状图）

// 联网搜索
import NetworkSearch from '../templates/NetworkSearch';

// 服务提示指令
const CHATsuggestions = [  // chat
    {
        label: '数量要求',
        icon: <QuantityRequirementIcon />,
        value: '搜索下关羽败走麦城的根本原因，3条就可以了。',
    },
    {
        label: '混合查询',
        icon: <HybridQueryIcon />,
        value: '关羽败走麦城的根本原因，请使用百度搜索引擎。',
    },
];

const SEALsuggestions = [  // 账户
    {
        label: '数量要求',
        icon: <QuantityRequirementIcon />,
        value: '查下软件研发部部有哪些人，3条就可以了。',
    },
    {
        label: '混合查询',
        icon: <HybridQueryIcon />,
        value: '查下软件研发部，研发工程师这个岗位有哪些人？以表格形式展示。',
    },
    {
        label: '账户管理',
        value: 'user',
        icon: <UserOutlined />,
        children: [
            {
                label: '查询账户',
                value: '查下lisi这个账户信息',
            },
            {
                label: '查询电话',
                value: '查下电话18107450001的账户信息',
            },
            {
                label: '查询邮箱',
                value: '查下邮箱lisi@qq.com的账户信息',
            },
            {
                label: '禁用账户',
                value: '禁用lisi这个账户',
            },
        ]
    },
    {
        label: '报表管理',
        value: 'report',
        icon: <LineChartOutlined />,
        children: [
            {
                label: '查询报表类型',
                value: '查下能力类型分类占比这份报表',
            },
            {
                label: '查询时间跨度',
                value: '查下每日活跃用户在60天以内情况',
            },
        ]
    },
];

const PLMSsuggestions = [  // 项目
    {
        label: '数量要求',
        icon: <QuantityRequirementIcon />,
        value: '查下工单等级为3级有哪些？3条就可以了。',
    },
    {
        label: '混合查询',
        icon: <HybridQueryIcon />,
        value: '查下工单等级为3级，类型为硬件的有哪些？',
    },
    {
        label: '工单管理',
        value: 'wo',
        icon: <WOIcon />,
        children: [
            {
                label: '编号查询',
                value: '查下工单编号为202502110001的信息',
            },
            {
                label: '类型查询',
                value: '查下工单类型为硬件的有哪些？',
            },
            {
                label: '时段查询',
                value: '查下2025年2月1日到2025年2月28日的工单有哪些？',
            },
            {
                label: '禁用工单',
                value: '禁用编号为202502110001的工单',
            },
        ]
    },
    {
        label: '报表管理',
        value: 'report',
        icon: <LineChartOutlined />,
        children: [
            {
                label: '查询报表类型',
                value: '查下工单年度类型统计报表',
            },
            {
                label: '查询时间跨度',
                value: '查下工单每日数量在60天以内的情况',
            },
        ]
    },
];

const SCMSsuggestions = [  // 供应链
    {
        label: '数量要求',
        icon: <QuantityRequirementIcon />,
        value: '查下供应产品类别为家具的供应商有哪些，3条就可以了。',
    },
    {
        label: '混合查询',
        icon: <HybridQueryIcon />,
        value: '查下主要供应产品是交换机，品牌是华为的供应商有哪些？',
    },
    {
        label: '供应管理',
        value: 'supplier',
        icon: <SupplierIcon />,
        children: [
            {
                label: '供应商名称查询',
                value: '查下新致腾这家供应商的信息',
            },
            {
                label: '供应商品牌查询',
                value: '查下能提供华为这个品牌的供应商有哪些？',
            },
            {
                label: '供应产品类别查询',
                value: '查下供应产品类别为家具的供应商有哪些？',
            },
            {
                label: '主要供应产品查询',
                value: '查下主要供应产品为交换机的供应商有哪些？',
            },
        ]
    },
    {
        label: '产品管理',
        value: 'product',
        icon: <ProfileOutlined />,
        children: [
            {
                label: '名称查询',
                value: '查下机械硬盘的库存还有多少？',
            },
            {
                label: '编码查询',
                value: '查下编码为X001020200001的产品',
            },
        ]
    },
    {
        label: '库存管理',
        value: 'inventory',
        icon: <AppstoreOutlined />,
        children: [
            {
                label: '名称查询',
                value: '查下笔记本电脑这个产品的库存',
            },
            {
                label: '编码查询',
                value: '查下编码为X001020200001产品的库存',
            },
        ]
    },
];

const CFMSsuggestions = [  // 云网盘
    {
        label: '数量要求',
        icon: <QuantityRequirementIcon />,
        value: '查找名称带有公司简介的文件有哪些，3条就可以了。',
    },
    {
        label: '混合查询',
        icon: <HybridQueryIcon />,
        value: '查下名称带有公司简介，类型是图标的文件有哪些？',
    },
    {
        label: '查找文件',
        icon: <FolderOutlined />,
        children: [
            {
                label: '名称查询',
                value: '查找下公司简介这份文件',
            },
            {
                label: '类型查询',
                value: '查找下类型为文档的文件',
            },
        ]
    }
];

const TEIIsuggestions = [  // 交通
    {
        label: '数量要求',
        icon: <QuantityRequirementIcon />,
        value: '查下湖天大道这条路上有多少个路口，3条就可以了。',
    },
    {
        label: '混合查询',
        icon: <HybridQueryIcon />,
        value: '查下湖天大道这条路上的路口，且路口类型是十字路口，以表格形式展示。',
    },
    {
        label: '路口管理',
        value: 'intersection',
        icon: <IntersectionIcon />,
        children: [
            {
                label: '查询路口',
                value: '查下房产局这个路口信息',
            },
            {
                label: '查询配时',
                value: '查下房产局这个路口的配时信息',
            },
        ]
    },
    {
        label: '报表管理',
        value: 'report',
        icon: <LineChartOutlined />,
        children: [
            {
                label: '查询报表类型',
                value: '查下路口主机分类占比这份报表信息',
            },
        ]
    },
];

const getSuggestions = (service) => {
    switch (service) {
        case 'seal':
            return SEALsuggestions;
        case 'plms':
            return PLMSsuggestions;
        case 'scms':
            return SCMSsuggestions;
        case 'cfms':
            return CFMSsuggestions;
        case 'teii':
            return TEIIsuggestions;
        default:
            return CHATsuggestions;
    }
}

const getPutOutFunctionName = () => {
    //  以下的函数名，需要展示大模型的输出
    return [
        'chat_network_crawler',
        'chat_network_search',
        'chat_network_news',
        'chat_network_hots',
    ]
}

// 代码高亮
const Code = props => {
    var _a;
    const { className, children } = props;
    const lang =
        ((_a =
            className === null || className === void 0 ? void 0 : className.match(/language-(\w+)/)) ===
            null || _a === void 0
            ? void 0
            : _a[1]) || '';
    if (typeof children !== 'string') return null;
    if (lang === 'mermaid') return <Mermaid
        code={children}
    />;
    return <HighlightCode
        lang={lang}
    >
        {children}
    </HighlightCode>;
};

const XinYuanWebChatX = (props) => {
    const [messageApi, contextHolder] = message.useMessage();
    const { token } = theme.useToken();

    const projectCode = useRef(CNF.projectCode);        //  项目代码，默认使用系统本身

    const loading = useRef(false);  //  加载状态
    const [content, setContent] = useState('');         //  当前输入内容
    const [hoverId, setHoverId] = useState('');         //  鼠标悬浮ID

    const senderRef = useRef(null);                     //  输入框高亮
    const service = useRef('');                         //  选择服务
    const isNetwork = useRef(0);                        //  是否联网


    const [isCommand, setIsCommand] = useState(false);  //  是否通过输入‘/’调用指令
    const [isHover, setIsHover] = useState(false);      //  是否悬浮
    const [publicCommandInfo, setPublicCommandInfo] = useState({});     //  指令库指令Ulid，使用指令库时赋值

    const dialogueUlid = useRef('');        //  对话Ulid
    const conversationId = useRef('');      //  会话ID


    /***************打印动画配置***************/
    const [enableAnimation, setEnableAnimation] = useState(true);
    const [hasNextChunk, setHasNextChunk] = useState(false);
    const [index, setIndex] = useState(0);
    const timer = useRef(-1);
    const renderStream = () => {
        if (messages.length > 0) {
            if (index >= messages[messages.length - 1].message.content) {
                clearTimeout(timer.current);
                setHasNextChunk(false);
                return;
            }
        }
        timer.current = setTimeout(() => {
            setIndex(prev => prev + 2);
            renderStream();
        }, 30);
    };

    useEffect(() => {
        if (messages.length > 0) {
            if (index === messages[messages.length - 1].message.content) return;
            setHasNextChunk(true);
            renderStream();
            return () => {
                clearTimeout(timer.current);
            };
        }
    }, [index]);
    /***************打印动画配置***************/


    /**
     * 网络搜索源开启状态
     * @param {*} value 
     */
    const setOpenNetworkSource = (value) => {
        props.changeIsOpenNetworkSource(value);
    }

    /**
     * 设置网络搜索源数据
     * @param {*} value 
     */
    const setNetworkSourceData = (value) => {
        props.changeNetworkSourceData(value);
    }

    /**
     * 初始化
     */
    const initialize = () => {
        setMessages([]);
        conversationId.current = '';
        dialogueUlid.current = '';
        // setContent(''); //  情况输入框
        loading.current = false;
    }

    /**
     * 输入“/”
     */
    useEffect(() => {
        //  调用指令
        if (content === '/') {
            setIsCommand(true);
        }
        //  撤销指令
        if (!content) {
            setIsCommand(false);
        }
        //  如果输入的第一个字符为“/”，则表示调用指令，之后的字符作为指令内容搜索的关键字
        if (content && content.charAt(0) === '/') {
            setCommandContentKeys(content.slice(1))
        }
    }, [content]);

    /**
     * 新建会话
     */
    useEffect(() => {
        initialize();
    }, [props.newSessionTag]);

    const callbacks = {
        // 请求完成
        onSuccess: messages => {
            let currentContent = '';
            let currentRequestId = '';
            for (let i = 0; i < messages.length; i++) {
                let item = messages[i];
                if (item) {
                    if (item.data !== '[DONE]') {
                        let data = JSON.parse(item.data);
                        currentContent += data.result;
                        // 请求Id
                        if (!currentRequestId) {
                            currentRequestId = data.id;
                        }
                    }
                }
            }
            createDialogueContent('assistant', currentContent,
                dialogueUlid.current,
                conversationId.current,
                currentRequestId,
            );
        },
        onError: error => {
            // console.error('onError', error);
        },
        onUpdate: msg => {
            // 加载已完成
            loading.current = false;
            // 更新滚动条
            ToScrollBottom('xinyuan-chat-id');
        },
    }

    // 数据提供
    const [provider] = useState(
        new XinYuanProvider({
            request: XRequest(CNF.onaiApi + 'completions', {
                manual: true,
                headers: AddRequestHeaders(),
                callbacks: callbacks,
            }),
        })
    );

    // Chat messages
    const { onRequest, setMessages, abort, messages, isRequesting } = useXChat({
        provider: provider,
    });

    /**
     * 打开历史会话
     */
    useEffect(() => {
        // 初始化历史对话内容
        if (props.messages.length > 0) {
            let ms = [];    //  重新组装会话数组
            for (let i = 0; i < props.messages.length; i++) {
                let item = props.messages[i];
                let chatMessage = {
                    id: i,
                    message: { role: item.role, content: item.content },
                    status: 'success',
                }
                ms.push(chatMessage);
            }
            setMessages(ms);
            conversationId.current = props.conversationId;
            dialogueUlid.current = props.dialogueUlid;
        } else {
            setMessages([]);
            conversationId.current = '';
            dialogueUlid.current = '';
        }
        setTimeout(() => {
            ToScrollBottom('xinyuan-chat-id');
        }, 100);
    }, [props.messages]);

    /**
     * 查看内容
     * @param {*} content 
     */
    const viewContent = (content, index) => {
        rootReactDom && rootReactDom.render(
            <AssistantBoxView
                preGroup={props.preGroup}
                open={true}
                senderRef={senderRef}
                content={content}
                index={index}
            />);
    }

    /**
     * 创建会话
     * @param {*} role 
     * @param {*} content 
     */
    const createDialogue = (role, content) => {
        $.ajax({
            url: `${CNF.api}dialogues`,
            headers: AddRequestHeaders(),
            type: 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'project_code': service.current ? service.current : projectCode.current,
                'model': props.model.value,
                'version': props.versionInfo.value,
                'title': content.split('\n')[0].slice(0, 50),
            }), success: function (data) {
                if (data.res === 0) {
                    dialogueUlid.current = data.dat.dialogue_ulid;  //  对话Ulid
                    conversationId.current = data.dat.conversation_id; // 会话Id
                    onRequest({
                        project_code: service.current ? service.current.toLocaleLowerCase() : "",
                        conversation_id: data.dat.conversation_id,
                        is_network: isNetwork.current,
                        model: props.model.value,
                        version_id: props.versionInfo.value,
                        stream: 1,
                        messages: [{ role: role, content: content }],
                        temperature: props.temperature,
                        top_p: props.topP,
                        max_tokens: props.versionInfo.max_tokens,
                    });
                    // 创建用户内容，用户对话内容联网数据为空
                    createDialogueContent(role, content, data.dat.dialogue_ulid, data.dat.conversation_id);
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }
        });
    }

    /**
     * 创建会话内容
     * @param {*} role 
     * @param {*} content 
     * @param {*} dialogueUlid 
     * @param {*} conversationId 
     * @param {*} requestId 
     * @param {*} networkDataType 
     * @param {*} networkDataList 
     * @returns 
     */
    const createDialogueContent = (role, content,
        dialogueUlid = '',
        conversationId = '',
        requestId = '',
    ) => {
        //  参数校验
        if (content === '') {
            return;
        }
        $.ajax({
            url: `${CNF.api}dialogue/contents`,
            headers: AddRequestHeaders(),
            type: 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'dialogue_ulid': dialogueUlid,
                'conversation_id': conversationId,
                'request_id': requestId,
                'role': role,
                'content': content,
            }), success: function (data) {
                if (data.res === 0) {
                    //
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }
        });
    }

    /**
     * 添加指令调用次数
     */
    const addPublicCommandUseCount = () => {
        $.ajax({
            url: `${CNF.api}command/publics/${publicCommandInfo.key}`,
            headers: AddRequestHeaders(),
            type: 'PUT',
            dataType: 'JSON',
            data: JSON.stringify({
                'action': 'ADDUSECOUNT',
                'title': publicCommandInfo.title
            }), success: function (data) {
                if (data.res === 0) {
                    //  增加成功，清空指令库指令
                    setPublicCommandInfo({});
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    // 布局相关
    const [commandContentKeys, setCommandContentKeys] = useState('');   // 指令搜索关键字

    // 自定义sender组件头部
    const senderHeaderNode = (<Sender.Header open={isCommand} closable={false}
        style={{ background: '#fff', borderRadius: '12px 12px 0 0' }}>
        <Flex
            vertical
            align='left'
            gap='small'
        >
            <CommandX
                senderRef={senderRef}
                setMessages={setContent}    // 更新输入框内容，为了兼顾之前的老版本
                setIsCommand={setIsCommand}
                setIsHover={setIsHover}
                setPublicCommandInfo={setPublicCommandInfo}
                commandContentKeys={commandContentKeys}
            />
        </Flex>
    </Sender.Header>
    )

    return <div style={{
        height: winHeight - 124,
        position: 'relative',
        width: isGTscreenWidth ? (props.isOpenHistory ? '70%' : '60%') : (props.isOpenHistory ? '80%' : '70%'),
        marginLeft: isGTscreenWidth ? (props.isOpenHistory ? '15%' : '20%') : (props.isOpenHistory ? '10%' : '15%'),
    }}>
        {contextHolder}
        <div id='xinyuan-chat-id' style={{
            height: winHeight - 264,
            scrollbarColor: '#d9d9d9 transparent',
            scrollbarWidth: 'thin',
            overflowY: 'auto',
            paddingTop: 45,
        }}>
            {
                // 欢迎组件
                loading.current || messages.length > 0 ? null : <Welcome
                    styles={{
                        title: { fontSize: 18 },
                        icon: { fontSize: 15 }
                    }}
                    icon={<Image height={40} style={{ borderRadius: 15, }} src={props.model.logo} preview={false} />}
                    variant='borderless'
                    title={'你好，我是' + props.model.value + '！'}
                    description={props.model.prompt}
                />
            }
            {
                // 内容输出
                messages && messages.map(({ id, message, status }, index) => {
                    let isLocal = message?.role === 'user' ? true : false;
                    return (
                        <Bubble
                            key={id}
                            style={{
                                marginBottom: 10,
                                marginRight: 10,
                            }}
                            styles={{
                                content: {
                                    background: isLocal ? global.THEMECOLOR : '#fff',
                                }
                            }}
                            variant='filled'
                            placement={isLocal ? 'end' : 'start'}
                            avatar={
                                isLocal ? (cookie.load(CNF.cookies.keyAvatarUrl) ? <Avatar src={CNF.ossApi + cookie.load(CNF.cookies.keyAvatarUrl)} preview='false' /> : <Avatar icon={<UserOutlined />} />)
                                    :
                                    <Avatar src={props.model.logo} preview='false' />
                            }
                            content={message?.content}
                            contentRender={(content) => {
                                const newContent = content.replace('/\n\n/g', '<br/><br/>');
                                return <Typography.Text style={{ color: isLocal ? '#fff' : '', border: 'solid 0px red' }}>
                                    <XMarkdown
                                        content={newContent}
                                        streaming={{ enableAnimation, hasNextChunk, animationConfig: { fadeDuration: 200 } }}
                                        className={isLocal ? '' : 'x-markdown-light'}
                                        style={{
                                            maxWidth: winWidth * (props.isOpenHistory ? 0.4 : 0.44),
                                            wordWrap: 'break-word',
                                            overflowX: 'hidden',
                                            overflowWrap: 'break-word',
                                        }}
                                        components={{
                                            code: Code,
                                            'think': XinYuanThink,
                                            'chart-pie-percent': ChartPiePercent,
                                            'chart-line-utacd': ChartLineUTACD,
                                            'chart-line-utecy': ChartLineUTECY,
                                            'org-structure-graph': OrgStructureGraph,
                                            'chart-line-date-count': ChartLineDateCount,
                                            'chart-interval-type-count': ChartIntervalTypeCount,
                                            'chart-il-year-amount': ChartILYearAmount,
                                            'chart-interval-month-io-amount': ChartIntervalMonthIOAmount,
                                            'network-search': (props) => <NetworkSearch
                                                {...props}
                                                setOpenNetworkSource={setOpenNetworkSource}
                                                setNetworkSourceData={setNetworkSourceData}
                                            />,
                                        }}
                                        config={{
                                            extensions: Latex(),
                                        }}
                                        paragraphTag='div'
                                    />
                                </Typography.Text>
                            }}
                            typing={isLocal || (index <= props.messages.length) ? false : {
                                step: 2,
                                interval: 50,
                            }}
                            onMouseEnter={() => { setHoverId(index); }}
                            onMouseLeave={() => { setHoverId(''); }}
                            footer={
                                isLocal ?
                                    <div style={{ visibility: hoverId === index ? 'visible' : 'hidden' }}>
                                        <Space size={token.paddingXXS}>
                                            <Popover placement='top' content='复制'>
                                                <Button color='default' variant='text' size='small' style={{ color: '#939394' }} icon={<CopyOutlined />}
                                                    onClick={() => {
                                                        if (navigator.clipboard && window.isSecureContext) {
                                                            navigator.clipboard.writeText(message.content || message).then(() => {
                                                                // 复制成功
                                                                messageApi.success('复制成功！', CNF.messageDuration);
                                                            }).catch((error) => {
                                                                // 复制失败
                                                                messageApi.error(error, CNF.messageDuration);
                                                            })
                                                        } else {
                                                            const input = document.createElement('textarea');
                                                            input.value = message.content || message;
                                                            document.body.appendChild(input);
                                                            input.select();
                                                            document.execCommand('copy');
                                                            document.body.removeChild(input);
                                                            messageApi.success('复制成功！', CNF.messageDuration);
                                                        }
                                                    }}
                                                />
                                            </Popover>
                                            <Popover placement='top' content='引用'>
                                                <Button color='default' variant='text' size='small' style={{ color: '#939394' }} icon={<EnterOutlined />}
                                                    onClick={() => {
                                                        setContent(message.content || message);
                                                    }}
                                                />
                                            </Popover>
                                        </Space>
                                    </div>
                                    :
                                    // AI气泡框，当鼠标悬浮，或者最后一个输出显示按钮
                                    <div style={{ visibility: (hoverId === index || index === messages.length - 1) ? 'visible' : 'hidden' }}>
                                        <Space size={token.paddingXXS}>
                                            <Popover placement='top' content='查看内容'>
                                                <Button color='default' variant='text' size='small' style={{ color: '#939394' }} icon={<FolderViewOutlined />}
                                                    onClick={() => {
                                                        viewContent(message.content, index);
                                                    }}
                                                />
                                            </Popover>
                                            <Popover placement='top' content='复制成Markdown'>
                                                <Button color='default' variant='text' size='small' style={{ color: '#939394' }} icon={<FileMarkdownOutlined />}
                                                    onClick={() => {
                                                        if (navigator.clipboard && window.isSecureContext) {
                                                            navigator.clipboard.writeText(message.content).then(() => {
                                                                // 复制成功
                                                                messageApi.success('复制成功！', CNF.messageDuration);
                                                            }).catch((error) => {
                                                                // 复制失败
                                                                messageApi.error(error, CNF.messageDuration);
                                                            })
                                                        } else {
                                                            const input = document.createElement('textarea');
                                                            input.value = message.content;
                                                            document.body.appendChild(input);
                                                            input.select();
                                                            document.execCommand('copy');
                                                            document.body.removeChild(input);
                                                            messageApi.success('复制成功！', CNF.messageDuration);
                                                        }
                                                    }}
                                                />
                                            </Popover>
                                            <Popover placement='top' content='复制内容'>
                                                <Button color='default' variant='text' size='small' style={{ color: '#939394' }} icon={<CopyOutlined />}
                                                    onClick={() => {
                                                        if (navigator.clipboard && window.isSecureContext) {
                                                            navigator.clipboard.writeText(ClearMarkdown(message.content)).then(() => {
                                                                // 复制成功
                                                                messageApi.success('复制成功！', CNF.messageDuration);
                                                            }).catch((error) => {
                                                                // 复制失败
                                                                messageApi.error(error, CNF.messageDuration);
                                                            })
                                                        } else {
                                                            const input = document.createElement('textarea');
                                                            input.value = ClearMarkdown(message.content);
                                                            document.body.appendChild(input);
                                                            input.select();
                                                            document.execCommand('copy');
                                                            document.body.removeChild(input);
                                                            messageApi.success('复制成功！', CNF.messageDuration);
                                                        }
                                                    }}
                                                />
                                            </Popover>
                                            {/* <Popover placement='top' title={null} color='#000' content={<span style={{ color: '#fff' }}>重新生成</span>}>
                                            <Button color='default' variant='text' size='small' style={{ color: '#939394' }} icon={<SyncOutlined />} />
                                        </Popover> */}
                                        </Space>
                                    </div>
                            }
                        />
                    )
                })
            }
            {
                // 请求加载
                loading.current ? <Bubble
                    style={{
                        marginBottom: 15,
                    }}
                    placement='start'
                    avatar={<Avatar src={props.model.logo} preview='false' />}
                    loading={true}
                /> : null
            }

        </div>
        <div style={{ position: 'absolute', width: '100%', bottom: 5, }}>
            <Suggestion
                items={getSuggestions(service.current)}
                onSelect={(nextContent) => {
                    setContent(nextContent);
                }}
            >
                {({ onTrigger, onKeyDown }) => {
                    return (
                        <Flex wrap gap={12}>
                            <Button icon={<PlusOutlined />}
                                onClick={() => {
                                    initialize();
                                }}
                            >新建会话</Button>
                            {
                                // 选择服务，联网搜索无异议。
                                CNF.callToolsModels.includes(props.model.value) && !service.current ? (
                                    <Button color={isNetwork.current ? 'primary' : 'default'} variant='outlined' icon={<GlobalOutlined />}
                                        onClick={() => {
                                            isNetwork.current = isNetwork.current ? 0 : 1;
                                            setIsHover(!isHover);  //  触发渲染用，无其它用途。
                                        }}
                                    >联网搜索</Button>
                                ) : ''
                            }
                            {
                                CNF.callToolsModels.includes(props.model.value) && props.services && props.services.length > 0 ? (
                                    <Select
                                        placeholder='选择服务'
                                        onChange={(value) => {
                                            service.current = value;
                                            props.changeService(value); // 切换服务，用于检索历史对话
                                        }}
                                        allowClear
                                        style={{ width: 110 }}
                                        showSearch={{ optionFilterProp: 'label' }}
                                        options={props.services.map((item) => {
                                            return {
                                                value: item.value,
                                                label: item.key,
                                            }
                                        })}
                                    />
                                ) : null
                            }
                            <Sender
                                placeholder='输入“/”创建和收藏指令，回车换行'
                                loading={isRequesting}
                                value={content}
                                submitType='shiftEnter'
                                header={senderHeaderNode}
                                ref={senderRef}     // 用户获取焦点
                                allowSpeech
                                style={{
                                    background: '#fff',
                                }}
                                actions={(_, info) => {
                                    const { SendButton, LoadingButton, ClearButton } = info.components;
                                    return (
                                        <Space size="small">
                                            <Popover placement='top' content='清空内容'>
                                                <ClearButton />
                                            </Popover>
                                            {isRequesting ? (
                                                <LoadingButton type='default' />
                                            ) : (
                                                <Popover placement='top' content='请输入你的问题'>
                                                    <SendButton type='primary' />
                                                </Popover>
                                            )}
                                        </Space>
                                    );
                                }}
                                onChange={(nextContent) => {
                                    if ((nextContent === '?' || nextContent === '？') && CNF.callToolsModels.includes(props.model.value)) {  //  弹出建议
                                        onTrigger();
                                    } else if (!nextContent) {
                                        onTrigger(false);
                                    }
                                    setContent(nextContent);
                                }}
                                onSubmit={(nextContent) => {
                                    if (conversationId.current) { // 对话已存在
                                        createDialogueContent('user', nextContent, dialogueUlid.current, conversationId.current);
                                        let newMassages = messages.map(obj => obj.message);
                                        newMassages.push({
                                            role: 'user',
                                            content: nextContent
                                        });
                                        onRequest({
                                            project_code: service.current ? service.current.toLocaleLowerCase() : "",
                                            conversation_id: conversationId.current,
                                            is_network: isNetwork.current,
                                            model: props.model.value,
                                            version_id: props.versionInfo.value,
                                            stream: 1,
                                            messages: newMassages,
                                            temperature: props.temperature,
                                            top_p: props.topP,
                                            max_tokens: props.versionInfo.max_tokens,
                                        });
                                    } else {
                                        // 创建对话
                                        createDialogue('user', nextContent);
                                    }
                                    setContent('');
                                    ToScrollBottom('xinyuan-chat-id');
                                    loading.current = true;
                                }}
                                onCancel={() => {
                                    abort();
                                    loading.current = false;
                                    // if (!isRequesting) loading.current = false;   //  正在请求不能中断输出
                                }}
                                onKeyDown={onKeyDown}
                            />
                        </Flex>
                    );
                }}
            </Suggestion>
        </div>
    </div>
}

export default XinYuanWebChatX;